<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="columns is-vcentered">
          <div class="column is-narrow">
            <p class="title">Cupones y regalos</p>
            <p class="subtitle is-6 has-text-grey">{{ total }} {{ vista === "certificados" ? (total === 1 ? "plantilla" : "plantillas") : (total === 1 ? "cupón" : "cupones") }}</p>
          </div>
          <div class="column is-3">
            <b-button icon-left="plus" icon-pack="fas" type="is-success" @click="openModalCreateCupon" expanded>Crear Cupón</b-button>
          </div>
        </div>
      </div>
    </section>

    <!-- Las plantillas de regalo (PDF, correo y usos) dan muchos códigos; los vouchers y descuentos, uno por persona -->
    <b-tabs v-model="pestana" type="is-boxed" class="mb-2" @input="cambiarVista">
      <b-tab-item label="Plantillas de regalo" icon="gift" icon-pack="fas"></b-tab-item>
      <b-tab-item label="Vouchers y descuentos" icon="ticket-alt" icon-pack="fas"></b-tab-item>
    </b-tabs>

    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field label-position="on-border" :label="i18n.name[iso]">
          <b-input v-model="filters.Nombre" type="search" @keyup.native.enter="buscar" expanded></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field label-position="on-border" label="Código">
          <b-input v-model="filters.Codigo" type="search" @keyup.native.enter="buscar" expanded></b-input>
        </b-field>
      </div>
      <template v-if="vista === 'otros'">
        <div class="column is-3">
          <b-field label-position="on-border" label="Correo">
            <b-input v-model="filters.Email" type="search" @keyup.native.enter="buscar" expanded></b-input>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field label-position="on-border" label="Origen">
            <b-select v-model="filters.Origen" expanded @input="buscar">
              <option :value="null">Todos</option>
              <option value="welcome-bonus">Welcome Bonus</option>
              <option value="renewal">Renovación</option>
              <option value="manual">Manual</option>
            </b-select>
          </b-field>
        </div>
      </template>
      <div class="column is-2">
        <b-field label-position="on-border" :label="i18n.status[iso]">
          <b-select v-model="filters.Estado" expanded @input="buscar">
            <option :value="null">Todos</option>
            <option value="active">Activo</option>
            <option value="inactive">Inactivo</option>
            <option value="pending">Pendiente</option>
            <option value="used">Usado</option>
            <option value="expired">Expirado</option>
            <option value="canceled">Cancelado</option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-narrow">
        <div class="buttons">
          <b-button icon-left="search" icon-pack="fas" type="is-info" @click="buscar">{{ i18n.search[iso] }}</b-button>
          <b-button icon-left="eraser" icon-pack="fas" type="is-danger is-light" @click="clearFilters"></b-button>
        </div>
      </div>
    </div>

    <b-table
      :data="cupones"
      :loading="loadingTableList"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      :current-page.sync="currentPage"
      @page-change="onPageChange"
      pagination-simple
      striped
      hoverable
      narrowed
      mobile-cards
    >
      <!-- ------------------------------------------- Certificados -->
      <template v-if="vista === 'certificados'">
        <b-table-column field="Nombre" :label="i18n.name[iso]" v-slot="props">
          <b>{{ props.row.Nombre || "—" }}</b>
          <div class="is-size-7 has-text-grey">{{ formatTipoCupon(props.row.TipoCupon) || "sin tipo" }}</div>
        </b-table-column>
        <b-table-column label="PDF" centered v-slot="props">
          <div class="tags is-centered">
            <b-tag v-for="i in ['es', 'en']" :key="i" :type="tienePdf(props.row, i) ? 'is-info is-light' : 'is-light'" size="is-small">
              {{ i.toUpperCase() }} {{ tienePdf(props.row, i) ? "✓" : "—" }}
            </b-tag>
          </div>
        </b-table-column>
        <b-table-column label="Disponible para" v-slot="props">
          <div class="tags">
            <b-tag v-for="u in usos(props.row)" :key="u" type="is-primary is-light" size="is-small">{{ u }}</b-tag>
            <span v-if="!usos(props.row).length" class="has-text-grey is-size-7">Sin definir</span>
          </div>
        </b-table-column>
        <b-table-column label="Envío" v-slot="props">
          <b-tag v-if="props.row.Certificado && props.row.Certificado.Activo" type="is-success" size="is-small">Configuración nueva v{{ props.row.Certificado.Version }}</b-tag>
          <b-tag v-else type="is-warning is-light" size="is-small">Envío anterior</b-tag>
        </b-table-column>
        <b-table-column label="Códigos" numeric v-slot="props">{{ (props.row.Codigo || []).length }}</b-table-column>
      </template>

      <!-- ------------------------------------------- Vouchers y descuentos -->
      <template v-else>
        <b-table-column field="Nombre" :label="i18n.name[iso]" v-slot="props">
          {{ props.row.Nombre || "—" }}
          <div class="is-size-7 has-text-grey">{{ categoria(props.row.Categoria) }}</div>
        </b-table-column>
        <b-table-column label="Para" v-slot="props">
          <span class="is-size-7">{{ (props.row.Email || [])[0] || "—" }}</span>
          <span v-if="(props.row.Email || []).length > 1" class="is-size-7 has-text-grey"> +{{ props.row.Email.length - 1 }}</span>
        </b-table-column>
        <b-table-column label="Origen" v-slot="props">
          <span class="is-size-7">{{ origen(props.row.Origen) }}</span>
        </b-table-column>
        <b-table-column label="Código" v-slot="props">
          <code class="is-size-7">{{ (props.row.Codigo || [])[0] || "—" }}</code>
        </b-table-column>
        <b-table-column label="Aplicado" centered v-slot="props">
          <b-tag v-if="props.row.Aplicado" type="is-info is-light" size="is-small">{{ props.row.AplicadoA || "Sí" }}</b-tag>
          <span v-else class="has-text-grey">—</span>
        </b-table-column>
      </template>

      <b-table-column field="MontoDescuento" label="Descuento" centered v-slot="props">
        {{ formatDiscount(props.row.MontoDescuento, props.row.TipoDescuento) }}
      </b-table-column>
      <b-table-column field="FechaCreacion" :label="i18n.creationDate[iso]" centered v-slot="props">
        <span class="is-size-7">{{ parseDate(props.row.FechaCreacion) }}</span>
      </b-table-column>
      <b-table-column field="FechaVencimiento" label="Vencimiento" centered v-slot="props">
        <span class="is-size-7">{{ parseDate(props.row.FechaVencimiento) }}</span>
      </b-table-column>
      <b-table-column field="Estado" :label="i18n.status[iso]" centered v-slot="props">
        <b-tag :type="estado(props.row.Estado).tipo" size="is-small">{{ estado(props.row.Estado).texto }}</b-tag>
      </b-table-column>

      <b-table-column label="Acciones" v-slot="props" centered>
        <div class="buttons is-centered is-flex-wrap-nowrap">
          <b-tooltip v-if="props.row.Categoria === 'certificate'" label="Configurar plantilla (PDF, correo y usos)" type="is-dark">
            <b-button icon-left="cog" icon-pack="fas" size="is-small" type="is-info" @click="abrirEditor(props.row)"></b-button>
          </b-tooltip>
          <b-tooltip label="Ver Códigos" type="is-primary is-light">
            <b-button icon-left="eye" icon-pack="fas" size="is-small" type="is-primary is-light" @click="openModalVerCodigos(props.row)"></b-button>
          </b-tooltip>
          <b-tooltip :label="i18n.generateCode[iso]" type="is-success is-light">
            <b-button
              icon-left="plus"
              icon-pack="fas"
              size="is-small"
              type="is-success is-light"
              @click="generarCodigo(props.row)"
              :loading="loadingGenerarCodigo === props.row._id"
            ></b-button>
          </b-tooltip>
        </div>
      </b-table-column>

      <template #empty>
        <p class="has-text-centered has-text-grey py-5">{{ loadingTableList ? "" : vista === "certificados" ? "No hay plantillas con esos filtros" : "No hay cupones con esos filtros" }}</p>
      </template>
      <template #footer>
        <div class="is-flex is-justify-content-flex-end">
          <b-field :label="i18n.quantity[iso]" horizontal custom-class="is-small">
            <b-select v-model="perPage" size="is-small" @input="onPerPageChange">
              <option v-for="n in [10, 20, 50, 100]" :key="n" :value="n">{{ n }}</option>
            </b-select>
          </b-field>
        </div>
      </template>
    </b-table>

    <!-- Modal Crear Cupón -->
    <b-modal v-model="ModalCreateCupon" :width="600" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Crear Cupón</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalCreateCupon = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field label="Nombre" label-position="on-border">
                <b-input
                  v-model="cupon.Nombre"
                  type="text"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="cupon.Nombre = null"
                  expanded
                  :maxlength="50"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>

            <div class="column is-6">
              <b-field label="Categoría" label-position="on-border">
                <b-select v-model="cupon.Categoria" expanded required @input="cambiarCategoria">
                  <option value="discount">Descuento</option>
                  <option value="travel-voucher">Travel Voucher</option>
                  <option value="certificate">Certificado</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field label="Aplicable A" label-position="on-border">
                <b-select v-model="cupon.AplicableA" expanded>
                  <option value="renewals">Renovaciones</option>
                  <option value="reservations">Reservaciones</option>
                  <option value="weeks">Semanas</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6" v-if="cupon.AplicableA !== 'weeks' && !esCertificado">
              <b-field label="Tipo Categoría" label-position="on-border">
                <b-select v-model="cupon.TipoCategoria" expanded>
                  <option value="contract">Contrato</option>
                  <option value="certificate">Certificado</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6" v-if="cupon.AplicableA !== 'weeks'">
              <b-field
                label="Tipo Cupón"
                label-position="on-border"
                :message="esCertificado && cupon.TipoCupon ? 'Con tipo, HubSpot y el capturador lo usan para los envíos de ese tipo. Solo elige uno si sustituye a otro.' : ''"
                :type="esCertificado && cupon.TipoCupon ? 'is-warning' : ''"
              >
                <b-select v-model="cupon.TipoCupon" expanded :loading="loadingTiposCupones">
                  <option v-if="esCertificado" :value="null">Certificado nuevo, sin tipo (recomendado)</option>
                  <option
                    v-for="tipo in tiposCupones"
                    :key="tipo"
                    :value="tipo"
                  >{{ formatTipoCupon(tipo) }}{{ esCertificado ? " (tipo de envío existente)" : "" }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field label="Tipo Descuento" label-position="on-border">
                <b-select v-model="cupon.TipoDescuento" expanded>
                  <option value="fixed">Monto Fijo</option>
                  <option value="percentage">Porcentaje</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field label="Monto Descuento" label-position="on-border">
                <b-input
                  v-model.number="cupon.MontoDescuento"
                  type="number"
                  expanded
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6" v-if="!esCertificado">
              <b-field label="Duración" label-position="on-border">
                <b-select v-model="cupon.Duracion" expanded>
                  <option value="onetime">Una vez</option>
                </b-select>
              </b-field>
            </div>

            <div class="column is-6">
              <b-field label="Fecha Vencimiento" label-position="on-border">
                <b-datepicker
                  v-model="cupon.FechaVencimiento"
                  placeholder="DD/MM/YYYY"
                  :min-date="new Date()"
                  :locale="iso"
                  icon="calendar"
                  icon-pack="fas"
                  expanded
                  append-to-body
                >
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field label="Alcance" label-position="on-border">
                <b-select v-model="cupon.Alcance" expanded>
                  <option value="individual">Individual</option>
                  <option value="group">Grupo</option>
                  <option value="general">General</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field label="Estado" label-position="on-border">
                <b-select v-model="cupon.Estado" expanded>
                  <option value="active">Activo</option>
                  <option value="inactive">Inactivo</option>
                  <option value="pending">Pendiente</option>
                </b-select>
              </b-field>
            </div>

            <div class="column is-12">
              <hr style="margin: 0 0 0.5rem 0" />
              <b-field>
                <b-switch v-model="asignarPrograma" @input="onTogglePrograma">
                  Aplicar a programa
                </b-switch>
              </b-field>
            </div>
            <div class="column is-12" v-if="asignarPrograma">
              <b-field label="Programa" label-position="on-border">
                <b-select
                  v-model="cupon.DistributorId"
                  expanded
                  placeholder="Seleccione un programa"
                >
                  <option
                    v-for="d in programDistributors"
                    :value="d.Id"
                    :key="d.Id"
                  >
                    {{ d.Nombre }}{{ d.ClubNombre ? ` (${d.ClubNombre})` : "" }}
                  </option>
                </b-select>
              </b-field>
              <p
                v-if="!programDistributors.length"
                class="has-text-grey is-size-7"
              >
                Sin programas disponibles
              </p>
            </div>

            <div class="column is-12 has-text-centered" v-if="errorCupon">
              <span style="color: #f14668; font-weight: bold">{{
                errorCupon
              }}</span>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="createCupon">
            <span style="color: #48c78e; font-weight: bold; font-size: 130%">{{
              i18n.save[iso]
            }}</span>
            <b-icon
              pack="fas"
              :icon="loadingCupon ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingCupon ? 'fa-spin' : ''"
            ></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>

    <!-- Modal Ver Códigos -->
    <b-modal v-model="ModalVerCodigos" :width="400" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            Códigos de {{ selectedCupon?.Nombre }}
          </p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalVerCodigos = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <b-table
            :data="selectedCupon?.Codigo || []"
            :striped="true"
            :hoverable="true"
            :narrowed="true"
          >
            <b-table-column label="Código" centered v-slot="props">
              {{ props.row }}
            </b-table-column>
            <template #empty>
              <div class="has-text-centered">
                <p>No hay códigos para este cupón</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>

    <!-- Editor del certificado: PDF, posiciones, correo y usos -->
    <b-modal v-model="editor.abierto" has-modal-card full-screen-mobile :width="1360" :can-cancel="false" :destroy-on-hide="true">
      <template #default="props">
        <certificado-editor v-if="editor.cuponId" :cupon-id="editor.cuponId" @close="props.close" @guardado="listCupones" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import i18n from "../../utils/i18n";
import CertificadoEditor from "./CertificadoEditor.vue";

export default {
  components: { CertificadoEditor },
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 20,
      pestana: 0,
      editor: { abierto: false, cuponId: null },
      hasInput: false,
      paginationOrder: "",
      inputPosition: "",
      inputDebounce: "",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,

      //Loading
      loadingTableList: false,
      loadingButton: false,

      //Data
      cupones: [],
      total: 0,

      //Modals
      ModalCreateCupon: false,
      ModalVerCodigos: false,

      //i18n
      i18n,
      iso: null,

      //Permissions
      permissions: "",

      tabFilters: 0,
      filters: {
        Nombre: null,
        Codigo: null,
        Email: null,
        Origen: null,
        Estado: null,
      },

      // Crear Cupón
      cupon: {
        Nombre: null,
        Categoria: "discount",
        TipoCategoria: "contract",
        TipoCupon: "hertz",
        TipoDescuento: "fixed",
        MontoDescuento: null,
        Duracion: "onetime",
        FechaVencimiento: null,
        AplicableA: "renewals",
        Alcance: "individual",
        Estado: "pending",
        DistributorId: null,
      },
      userDistributors: [],
      allDistributors: [],
      asignarPrograma: false,
      loadingCupon: false,
      errorCupon: false,

      // Ver Códigos
      selectedCupon: null,
      loadingGenerarCodigo: null,

      // Tipos Cupones
      tiposCupones: [],
      loadingTiposCupones: false,
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    //Permissions
    this.permissions = localStorage.getItem("role");
    this.loadUserDistributors();
    if (this.isAdmin) await this.loadAllDistributors();

    await Promise.all([
      this.listCupones(),
      this.fetchTiposCupones(),
    ]);
  },
  computed: {
    vista() {
      return this.pestana === 0 ? "certificados" : "otros";
    },
    esCertificado() {
      return this.cupon.Categoria === "certificate";
    },
    isAdmin() {
      return localStorage.getItem("role") === "admin";
    },
    programDistributors() {
      return this.isAdmin ? this.allDistributors : this.userDistributors;
    },
  },
  methods: {
    async loadAllDistributors() {
      try {
        const club = JSON.parse(localStorage.getItem("club") || "{}");
        const params = { Activo: true };
        if (club?.Id) params.ClubId = club.Id;
        const { data } = await axios.get(
          `${API_URL}/system/distributor/list`,
          { params },
        );
        const list = data?.data || data || [];
        const clubNombre = club?.Nombre || null;
        this.allDistributors = (Array.isArray(list) ? list : []).map((d) => ({
          ...d,
          ClubNombre: clubNombre,
        }));
      } catch (err) {
        console.error("Error loading all distributors:", err);
        this.allDistributors = [];
      }
    },
    loadUserDistributors() {
      try {
        const raw = localStorage.getItem("distributors");
        const list = raw ? JSON.parse(raw) : [];
        this.userDistributors = Array.isArray(list) ? list : [];
      } catch (e) {
        this.userDistributors = [];
      }
    },
    onTogglePrograma(val) {
      if (val) {
        const list = this.programDistributors;
        this.cupon.DistributorId = list.length === 1 ? list[0].Id : null;
      } else {
        this.cupon.DistributorId = null;
      }
    },
    async fetchTiposCupones() {
      try {
        this.loadingTiposCupones = true;
        const { data } = await axios.get(`${API_URL}/cupones/tipos-cupones`);
        this.tiposCupones = data?.data || [];
        if (
          this.tiposCupones.length &&
          !this.tiposCupones.includes(this.cupon.TipoCupon)
        ) {
          this.cupon.TipoCupon = this.tiposCupones[0];
        }
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al cargar tipos de cupones",
          type: "is-danger",
        });
      } finally {
        this.loadingTiposCupones = false;
      }
    },
    async listCupones() {
      try {
        this.loadingTableList = true;
        const texto = (v) => (typeof v === "string" && v.trim() ? v.trim() : undefined);
        const { data } = await axios.post(`${API_URL}/cupones/list`, {
          Vista: this.vista,
          Nombre: texto(this.filters.Nombre),
          Codigo: texto(this.filters.Codigo),
          Email: this.vista === "otros" ? texto(this.filters.Email) : undefined,
          Origen: this.vista === "otros" ? this.filters.Origen || undefined : undefined,
          Estado: this.filters.Estado || undefined,
          pagina: this.currentPage,
          porPagina: this.perPage,
        });
        this.cupones = data?.cupones || [];
        this.total = data?.total || 0;
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: err?.response?.data?.message || "Error al consultar cupones",
          type: "is-danger",
        });
      } finally {
        this.loadingTableList = false;
      }
    },
    buscar() {
      this.currentPage = 1;
      this.listCupones();
    },
    cambiarVista() {
      this.cupones = [];
      this.filters.Email = null;
      this.filters.Origen = null;
      this.buscar();
    },
    abrirEditor(cupon) {
      this.editor = { abierto: true, cuponId: cupon._id };
    },
    tienePdf(cupon, idioma) {
      return Boolean(cupon.Certificado?.Pdf?.[idioma]?.Archivo);
    },
    usos(cupon) {
      const d = cupon.Certificado?.DisponiblePara || {};
      const lista = [];
      if (d.CampanasQr) lista.push("Campañas QR");
      if (d.Clubes?.length) lista.push(`${d.Clubes.length} club${d.Clubes.length > 1 ? "es" : ""}`);
      if (d.Distribuidores?.length) lista.push(`${d.Distribuidores.length} distribuidor${d.Distribuidores.length > 1 ? "es" : ""}`);
      (d.HubSpot || []).forEach((g) => lista.push(`HubSpot: ${g}`));
      return lista;
    },
    categoria(c) {
      return { discount: "Descuento", "travel-voucher": "Travel Voucher", certificate: "Certificado" }[c] || c || "—";
    },
    origen(o) {
      return { "welcome-bonus": "Welcome Bonus", renewal: "Renovación", manual: "Manual" }[o] || "—";
    },
    estado(e) {
      return (
        {
          active: { texto: "Activo", tipo: "is-success" },
          inactive: { texto: "Inactivo", tipo: "is-light" },
          pending: { texto: "Pendiente", tipo: "is-warning" },
          used: { texto: "Usado", tipo: "is-info" },
          expired: { texto: "Expirado", tipo: "is-danger" },
          canceled: { texto: "Cancelado", tipo: "is-dark" },
        }[e] || { texto: e || "—", tipo: "is-light" }
      );
    },
    onPerPageChange() {
      this.buscar();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.listCupones();
    },
    parseDate(value) {
      moment.locale(this.iso);
      return value ? moment(value).format("MMMM D, YYYY") : "-";
    },
    formatTipoCupon(value) {
      if (!value) return '';
      return value
        .replace(/([A-Z])/g, ' $1')
        .replace(/([a-zA-Z])(\d)/g, '$1 $2')
        .replace(/^./, (c) => c.toUpperCase())
        .trim();
    },
    formatDiscount(amount, type) {
      if (!amount && amount !== 0) return "-";
      if (type === "percentage") {
        return `${amount}%`;
      }
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(amount);
    },
    openModalCreateCupon() {
      this.cupon = {
        Nombre: null,
        Categoria: "discount",
        TipoCategoria: "contract",
        TipoCupon: this.tiposCupones.length ? this.tiposCupones[0] : null,
        TipoDescuento: "fixed",
        MontoDescuento: null,
        Duracion: "onetime",
        FechaVencimiento: null,
        AplicableA: "renewals",
        Alcance: "individual",
        Estado: "pending",
        DistributorId: null,
      };
      if (this.vista === "certificados") this.cambiarCategoria("certificate");
      this.asignarPrograma = false;
      this.errorCupon = false;
      this.ModalCreateCupon = true;
    },
    // Un certificado nuevo: activo, sin tipo y 100% en reservaciones (como los HTS); el resto vuelve a lo de siempre
    cambiarCategoria(categoria) {
      this.cupon.Categoria = categoria;
      if (categoria === "certificate") {
        Object.assign(this.cupon, {
          TipoCategoria: "certificate",
          TipoCupon: null,
          TipoDescuento: "percentage",
          MontoDescuento: 100,
          AplicableA: "reservations",
          Estado: "active",
        });
      } else {
        Object.assign(this.cupon, {
          TipoCategoria: "contract",
          TipoCupon: this.tiposCupones.length ? this.tiposCupones[0] : null,
          Estado: "pending",
        });
      }
    },
    async createCupon() {
      try {
        if (!this.cupon.Categoria) {
          this.errorCupon = "La categoría es requerida";
          return;
        }
        if (this.asignarPrograma && !this.cupon.DistributorId) {
          this.errorCupon = "Debe seleccionar un programa";
          return;
        }

        this.loadingCupon = true;

        // Preparar payload
        const payload = {
          ...this.cupon,
          CreadoPor: localStorage.getItem("user"),
          FechaCreacion: Date.now(),
        };

        // Si AplicableA es "weeks", nulificar TipoCategoria y TipoCupon
        if (payload.AplicableA === "weeks") {
          payload.TipoCategoria = null;
          payload.TipoCupon = null;
        }

        // Convertir FechaVencimiento a timestamp
        if (payload.FechaVencimiento instanceof Date) {
          payload.FechaVencimiento = payload.FechaVencimiento.getTime();
        }

        // Remove Codigo from payload - codes are added separately
        delete payload.Codigo;
        if (payload.Categoria === "certificate") delete payload.Duracion;

        const { data: creado } = await axios.post(`${API_URL}/cupones/create`, payload);

        this.loadingCupon = false;
        this.ModalCreateCupon = false;

        this.listCupones();

        // Un certificado se configura enseguida: PDF, posiciones, correo y usos
        if (creado?.Categoria === "certificate" && creado._id) {
          this.$buefy.toast.open({ message: "Plantilla creada: sube su PDF y configura el correo", type: "is-success" });
          this.abrirEditor(creado);
          return;
        }

        this.$buefy.dialog.alert({
          message: "Cupón creado con éxito",
          type: "is-success",
          hasIcon: true,
          icon: "check",
          iconPack: "fas",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      } catch (err) {
        console.log(err);
        this.loadingCupon = false;
        const msg = err?.response?.data?.error || err?.response?.data?.message;
        this.errorCupon = msg || "Error al crear cupón";
      }
    },
    openModalVerCodigos(cupon) {
      this.selectedCupon = cupon;
      this.ModalVerCodigos = true;
    },
    generarCodigo(cupon) {
      this.$buefy.dialog.confirm({
        title: this.i18n.generateCode[this.iso],
        message: this.i18n.generateCode__confirm[this.iso],
        confirmText: this.i18n.generateCode[this.iso],
        cancelText: this.i18n.cancel[this.iso],
        type: "is-success",
        hasIcon: true,
        icon: "plus-circle",
        iconPack: "fas",
        onConfirm: async () => {
          try {
            this.loadingGenerarCodigo = cupon._id;
            const payload = {};
            
            await axios.put(`${API_URL}/cupones/add-code/${cupon._id}`, payload);
            
            this.loadingGenerarCodigo = null;
            this.$buefy.toast.open({
              message: this.i18n.generateCode__success[this.iso],
              type: "is-success",
            });
            this.listCupones();
          } catch (err) {
            console.log(err);
            this.loadingGenerarCodigo = null;
            const msg = err?.response?.data?.error || err?.response?.data?.message;
            this.$buefy.toast.open({
              message: msg || this.i18n.generateCode__error[this.iso],
              type: "is-danger",
            });
          }
        },
      });
    },
    async clearFilters() {
      this.filters = {
        Nombre: null,
        Codigo: null,
        Email: null,
        Origen: null,
        Estado: null,
      };
      this.buscar();
    },
  },
};
</script>
